import React from 'react';
import DashboardPreview from 'pages/Dashboard/DashboardPreview';

const DashboardViewTab = ({
  formData,
  widgetData,
  openWidgetSelector,
  edit = false,
  compactPreview = false,
}) => {
  return (
    <div className="d-flex flex-column w-100 h-100">
      <div className="d-flex flex-column w-100 h-100 user-select-none position-relative">
        <div className="d-flex flex-row flex-grow-1 overflow-auto border border-1 border-white bg-background">
          <DashboardPreview
            definedWidgetData={widgetData}
            list={formData.layout}
            setList={() => {}}
            openWidgetSelector={openWidgetSelector}
            uninteractable
            edit={edit}
            compactPreview={compactPreview}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardViewTab;
